import React from 'react';
import { Table, TableBody, TableCell, TableRow } from '@mui/material';
import { getFormattedCellValue, tableStyles } from './details-table-helpers';

interface ArrayTableProps {
    values: any[]; // the structure comes from the data models.
    label?: string;
}

const ArrayBasedTableRow = ({
    label,
    values,
}: ArrayTableProps): React.JSX.Element => {
    return (
        <TableRow key={label}>
            {label && <TableCell sx={tableStyles.colorKey}>{label}</TableCell>}
            <TableCell sx={tableStyles.colorValue}>
                {React.Children.toArray(
                    values.map((rowValue) => (
                        <Table sx={tableStyles.innerListTable}>
                            <TableBody>
                                <TableRow key={`${label}_${rowValue}`}>
                                    <TableCell
                                        sx={tableStyles.nestedColorValue}
                                    >
                                        {getFormattedCellValue(rowValue)}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    ))
                )}
            </TableCell>
        </TableRow>
    );
};

export default ArrayBasedTableRow;
